<ion-header>
  <ind-page-title *ngIf="pageTitle" [viewData]="pageTitle" (onControlClick)="onButtonClicked($event)"></ind-page-title>
</ion-header>
<ion-content *ngIf="formMetadata && rawDataForDisplay">
  <ind-display-form
    [formMetadata]="formMetadata"
    [rawData]="rawDataForDisplay"
    [linkedEntityDBPrefix]="medicalInquiryLinkedEntityPrefix"
    [referencingEntityName]="'indskr_medicalinquiryid'"
    [isEditEnabled]="false">
  </ind-display-form>
</ion-content>
<div *ngIf="loadingDisplay && selectedMI" class="medical-inquiry-detail-placeholder">
  <ion-spinner name="crescent"></ion-spinner>
</div>
<div *ngIf="formMetadata && !rawDataForDisplay && !loadingDisplay" class="medical-inquiry-detail-placeholder">
  <p>{{ 'NO_DATA' | translate }}</p>
</div>
<div *ngIf="!formMetadata && selectedMI" class="medical-inquiry-detail-placeholder">
  <p>{{ 'ONE_KEY_DISPLAY_FORM_NO_FORMS_ERR' | translate }}</p>
</div>
